<template>
  <p>Register for the event here</p>
  <button @click="register">Register Me</button>
</template>

<script>
export default {
  props: ['event'],
  inject: ['GlobalStore'],
  methods: {
    register() {
      //Call to API
      // then redirect

      this.GlobalStore.flashMessage =
        'You are successfully registered for ' + this.event.title

      setTimeout(() => {
        this.GlobalStore.flashMessage = ''
      }, 3000)

      this.$router.push({
        name: 'EventDetails',
      })
    },
  },
}
</script>

<style></style>
